/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConfigFeatureToggleResponse } from '../../models/config-feature-toggle-response';

export interface GetConfigFeatureToggle$Params {
  configId: string;
  feature: 'SHOP_RENTER_PROCESS_PRODUCT_SPECIALS' | 'SHOP_RENTER_FILTER_PRODUCT_SPECIALS_BY_DATE' | 'SHOP_RENTER_PRODUCT_SPECIAL_HALF_OPEN_TIME_WINDOW_IS_VALID' | 'SHOP_RENTER_PRODUCT_SPECIAL_OPEN_TIME_WINDOW_IS_VALID' | 'RIMIKER_DRS' | 'POWERLIFE_DRS' | 'ENABLE_GTIN_USAGE_AT_MAPPING' | 'UNIT_PRICE' | 'DRS_IN_PRICE' | 'SPECIAL_UNIT_PRICE' | 'SPECIAL_DRS_IN_PRICE' | 'SPECIAL_GROSS_PRICE';
}

export function getConfigFeatureToggle(http: HttpClient, rootUrl: string, params: GetConfigFeatureToggle$Params, context?: HttpContext): Observable<StrictHttpResponse<ConfigFeatureToggleResponse>> {
  const rb = new RequestBuilder(rootUrl, getConfigFeatureToggle.PATH, 'get');
  if (params) {
    rb.path('configId', params.configId, {});
    rb.path('feature', params.feature, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConfigFeatureToggleResponse>;
    })
  );
}

getConfigFeatureToggle.PATH = '/config/{configId}/feature-toggle/{feature}';
